import React from "react";
import { ReactComponent as Tick } from "../assets/components-icons/tick.svg";
import { UserContext } from "../context/user";
import { ExtraContext } from "../context/ExtraFunctions";
import Server_Side_login from "../strapi/handle_user_auth_functions/Server_side_login";
import RegisterAuth from "../strapi/handle_user_auth_functions/Server_side_register";
import { useHistory } from "react-router-dom";
import { ReactComponent as Google } from "../assets/social-icons/svg/035-google-plus.svg";
import { Button } from '../components/Layout/Elements';

const LoginRegister = () => {
  const {
    authFilters: {
      username_login,
      username_register,
      email,
      password_login,
      password_register,
    },
    handleForm,
  } = React.useContext(ExtraContext);

  const { get_user } = React.useContext(UserContext);
  const { handleAlert, setGif } = React.useContext(ExtraContext);

  const [errors, setErrors] = React.useState({
    error_login: "",
    error_register: "",
  });

  let { error_login, error_register } = errors;
  let history = useHistory();

  return (
    <section className="container-grid-parent div-control-colors">
      <div className="parent-grid">
        <div className="login-form">
          <h5> Sign in </h5>
          <div className="border-line-form"></div>
          <p className="auth-descr">Lorem ipsum dolor sit amet.</p>

          <div className="form-control-vanilla">
            <label> Username </label>
            <input
              value={username_login}
              type="text"
              onChange={handleForm}
              name="username_login"
            />
          </div>

          <div className="form-control-vanilla">
            <label>Password</label>
            <input
              value={password_login}
              onChange={handleForm}
              type="password"
              name="password_login"
            />
          </div>

          <Button
          bg='var(--navbar-bg)'
          padding='10px'
          width='100%'
          maxWidth='150px'
          color='white'
          fontWeight='bold'
          fontSize='13.5px'
            onClick={(e) => {
              Server_Side_login(
                e,
                get_user,
                username_login,
                password_login,
                handleAlert,
                setGif,
                history,
                errors,
                setErrors
              );
            }}
            type="submit"
          >
            Log in
          </Button>
          <p className="auth-errors">{error_login}</p>
        </div>

        <div className="in-middle">
          <div className="straight-border-top"></div>
          <span className="rotate-vanilla">or</span>
          <div className="straight-border-bottom"></div>
        </div>

        <div className="register-form">
          <h5> Register </h5>
          <div className="border-line-form"></div>
          <p className="auth-descr"> Lorem ipsum dolor sit amet. </p>

          <div className="form-control-vanilla">
            <label>Username</label>
            <input
              value={username_register}
              onChange={handleForm}
              type="text"
              name="username_register"
            />
          </div>

          <div className="form-control-vanilla">
            <label>Password</label>
            <input
              value={password_register}
              onChange={handleForm}
              type="password"
              name="password_register"
            />
          </div>

          <div className="form-control-vanilla">
            <label>Email address</label>
            <input
              onChange={handleForm}
              value={email}
              type="email"
              name="email"
            />
          </div>

          <Button
          bg='var(--navbar-bg)'
          padding='10px'
          width='100%'
          maxWidth='150px'
          color='white'
          fontWeight='bold'
          fontSize='13.5px'
            onClick={(e) => {
              RegisterAuth(
                e,
                username_register,
                password_register,
                email,
                get_user,
                handleAlert,
                setGif,
                history,
                errors,
                setErrors
              );
            }}
            className="login-btn"
          >
            Register
          </Button>
          <p className="auth-errors">{error_register}</p>

          <div className="providers">
            <Google className="svgAll" />
            <a href="https://pizza-store-react-app.herokuapp.com/connect/google">
              Register with Google
            </a>
          </div>

          <h4>Sign up today and you will be able to:</h4>

          <div className="bonuses-register">
            <div>
              <Tick className="tick-svg" />
              <small>Lorem ipsum dolor sit amet.</small>
            </div>
            <div>
              <Tick className="tick-svg" />
              <small>Lorem ipsum dolor sit amet.</small>
            </div>
            <div>
              <Tick className="tick-svg" />
              <small>Lorem ipsum dolor sit amet.</small>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { LoginRegister as default };
